import React, { useEffect } from "react";
import Cookies from "../../../utils/cookies";
import fetch from "../../../utils/fetch";

interface Props {}

const Logout: React.FC<Props> = () => {
    useEffect(() => {
        (async () => {
            await new fetch("/auth/logout", {}, { success: false, error: false }).get();
        })();

        new Cookies().delete("token");
        new Cookies().delete("access_token");

        setTimeout(() => {
            window.location.href = "/";
        }, 300);
    });

    return <></>;
};

export default Logout;
